import styles from './styles.module.scss';

type ConfidenceLevelBadgeProps = {
  nivel: string;
  cor: string;
  descricao?: string;
  disabled?: boolean;
};

export const ConfidenceLevelBadge = ({ nivel, cor, disabled = false }: ConfidenceLevelBadgeProps) => {
  const disabledColor = '#959595';
  const disabledBgColor = '#f5f5f5';

  const getBgColor = (color: string) => {
    const normalizedColor = color?.toLowerCase();
    const bgMap: Record<string, string> = {
      '#378ef0': '#F5F9FE',
      '#33ab84': '#F5FBF9',
      '#f5a623': '#FEF9F0',
      '#e53935': '#FEF5F5',
      '#e83f3f': '#FEF5F5',
    };
    return bgMap[normalizedColor] || '#F5F9FE';
  };

  const activeColor = disabled ? disabledColor : cor;
  const activeBgColor = disabled ? disabledBgColor : getBgColor(cor);

  return (
    <div className={`${styles.container} ${disabled ? styles.disabled : ''}`} style={{ backgroundColor: activeBgColor }}>
      <div className={styles.content}>
        <span className={styles.label} style={{ color: activeColor }}>
          Nível de confiança
        </span>
        <div className={styles.badge} style={{ backgroundColor: activeColor }}>
          <span className={styles.badgeText}>{nivel}</span>
        </div>
      </div>
    </div>
  );
};
